// extracted by mini-css-extract-plugin
export var baseButton = "_uy-0";
export var controlsArrowKeys = "_uy-1";
export var controlsResetButton = "_uy-2";
export var lightGameButton = "_uy-4 _uy-0";
export var playAgainButton = "_uy-5 _uy-0";
export var startGameButton = "_uy-3 _uy-0";